// extracted by mini-css-extract-plugin
export var blue = "styles-module--blue--2ca09";
export var bottom = "styles-module--bottom--59709";
export var circle = "styles-module--circle--962a2";
export var done = "styles-module--done--0d143";
export var green = "styles-module--green--9b7dc";
export var inputs = "styles-module--inputs--6044b";
export var responsive = "styles-module--responsive--3677f";
export var square = "styles-module--square--6cf45";
export var title = "styles-module--title--0319a";
export var top = "styles-module--top--532b9";
export var wrapper = "styles-module--wrapper--1f919";